import { render, staticRenderFns } from "./BindCreative.vue?vue&type=template&id=b84ff3ce&scoped=true"
import script from "./BindCreative.vue?vue&type=script&lang=js"
export * from "./BindCreative.vue?vue&type=script&lang=js"
import style0 from "./BindCreative.vue?vue&type=style&index=0&id=b84ff3ce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b84ff3ce",
  null
  
)

export default component.exports